import firebase from 'firebase/app'
import 'firebase/auth'

let authReadyPromise = null

export const ensureFirebaseAuth = () => {
  const auth = firebase.auth()

  if (auth.currentUser) {
    return Promise.resolve(auth.currentUser)
  }

  if (!authReadyPromise) {
    authReadyPromise = auth.signInAnonymously()
      .then(({ user }) => user)
      .catch(error => {
        console.error('[Firebase] signInAnonymously failed, will retry on next request.', error)
        authReadyPromise = null
        throw error
      })
  }

  return authReadyPromise
}
